import React from "react";
import { Card, Col, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import AdminPannelDashBoardLayout from "../../../../layout/DashBoardLayouts/AdminPannelDashBoardLayout";

const CustomerData = [
  {
    SrNo: 1,
    Customer_Id: 176464,
    Name: "Sunraj Cunstruction",
    Email_Id: "vickym@gmail.com",
    Mobile_No: "8624043380",
    Location: "Nagpur",
  },
  {
    SrNo: 2,
    Customer_Id: 276464,
    Name: "Sunraj Cunstruction",
    Email_Id: "vickym@gmail.com",
    Mobile_No: "8624043380",
    Location: "Nagpur",
  },
  {
    SrNo: 3,
    Customer_Id: 376464,
    Name: "Sunraj Cunstruction",
    Email_Id: "vickym@gmail.com",
    Mobile_No: "8624043380",
    Location: "Nagpur",
  },
  {
    SrNo: 4,
    Customer_Id: 476464,
    Name: "Sunraj Cunstruction",
    Email_Id: "vickym@gmail.com",
    Mobile_No: "8624043380",
    Location: "Nagpur",
  },
];
const Builder = () => {
  return (
    <>
      <AdminPannelDashBoardLayout>
        <Row>
          <Col xs={12}>
            <Card className="mb-4">
              <Card.Header>
                <h3 className="my-3">Builder/Developer</h3>
              </Card.Header>
              <Card.Body>
                <Table>
                  <thead>
                    <tr>
                      <td scope="col">Sr. No.</td>
                      <td scope="col">Builder Id</td>
                      <td scope="col">Company Name</td>
                      <td scope="col">Email Id</td>
                      <td scope="col">Mobile No.</td>
                      <td scope="col">Location</td>
                    </tr>
                  </thead>
                  <tbody>
                    {CustomerData.map((Item) => (
                      <tr key={Item.index}>
                        <td scope="row">{Item.SrNo}</td>
                        <td>
                          <Link to="/builder-single-details">
                            {Item.Customer_Id}
                          </Link>
                        </td>
                        <td>{Item.Name}</td>
                        <td>{Item.Email_Id}</td>
                        <td>{Item.Mobile_No}</td>
                        <td>{Item.Location}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </AdminPannelDashBoardLayout>
    </>
  );
};

export default Builder;
